const regionSelector = () => {
    var _a;
    const regions = (_a = window.regionSelector) === null || _a === void 0 ? void 0 : _a.regions;
    const currentRegion = document.querySelectorAll('[data-current-region]');
    const regionSelector = document.querySelectorAll('[data-region-selector]');
    if (regions) {
        regions.forEach((region) => {
            if (region.is_current_store) {
                currentRegion === null || currentRegion === void 0 ? void 0 : currentRegion.forEach((div) => {
                    div.innerHTML = region.short_name;
                });
                regionSelector === null || regionSelector === void 0 ? void 0 : regionSelector.forEach((select) => {
                    select.innerHTML = `${select.innerHTML} <option value='${region.domain}' selected="selected">${region.name}</option>`;
                });
            }
            else {
                regionSelector === null || regionSelector === void 0 ? void 0 : regionSelector.forEach((select) => {
                    select.innerHTML = `${select.innerHTML} <option value='${region.domain}'>${region.name}</option>`;
                });
            }
        });
    }
    regionSelector === null || regionSelector === void 0 ? void 0 : regionSelector.forEach((select) => {
        select.addEventListener('change', () => {
            window.location.href = select.value;
        });
    });
};
export { regionSelector };
